export default __webpack_public_path__ + "static/media/gallery_07.6d89e239.jpg";